import React from "react";
import { Col } from "antd";

export function Clients() {
  return <Col style={{ marginTop: "20px" }}>Clients</Col>;
}
